module.exports = __webpack_public_path__ + "static/media/testen-er-ferdig.b962715f.mp3";